//@TODO - Change BASE_URL to blank prior to pushing to production
const BASE_URL = "";
const API_URL = "https://api.tintworld.com";
const LARAVEL_URL = "http://localhost";

export { BASE_URL, API_URL, LARAVEL_URL };
